import { EVENT } from "@/constants/event";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useLogin } from "../LoginModal";
import styles from "./index-new.module.less";

import NotificationCenter from "./NotificationCenter";

import { AD_POSITION } from "@/constants/ads";
import useAppStore from "@/context/store";
import { getAds } from "@/services";
import { useUpdateEffect } from "ahooks";
import dynamic from "next/dynamic";
import { match } from "path-to-regexp";
import { TrackerDiv } from "../Tracker";
import Avatar from "./Avatar";

import LogoWithOrg from "../LogoWithOrg";
import MembershipDropdown from "./MembershipDropdown";

const Search = dynamic(import("./search"), { ssr: false });

export default function Header({ isMobile, searchWord, sideNavVisible }) {
  const router = useRouter();

  const { user, adTopConfig } = useAppStore(
    ({ user, setStore, ads, adTopConfig }) => ({
      user,
      setStore,
      ads,
      adTopConfig,
    })
  );

  // 首页控制搜索框的显示隐藏
  const [searchVisible, setSearchVisible] = useState(false);

  const headerRef = useRef(null);
  const isHome = router.pathname === "/";

  // 切换页面时，获取指定页面吸顶广告
  useUpdateEffect(() => {
    const matchConfig = adTopConfig?.ads?.find((ad) => {
      return match(ad?.path)(router.asPath);
    });
    // 移除指定页面广告
    const filterFn = (ads) => {
      return (ads || []).filter(
        (ad) => ad?.position?.id !== AD_POSITION.TOP_PAGE
      );
    };

    // 当有指定页面吸顶广告配置时
    if (matchConfig) {
      getAds({
        positions: [AD_POSITION.TOP_PAGE],
        variables: {
          user_tag: [matchConfig.user_tag],
        },
      }).then((res) => {
        // 更新广告信息, 删除旧的指定页面广告
        useAppStore.setState((prev) => {
          return {
            ads: [...res, ...filterFn(prev.ads)],
          };
        });
      });
    } else {
      // 移除指定页面广告
      useAppStore.setState((prev) => {
        return {
          ads: [...filterFn(prev.ads)],
        };
      });
    }
  }, [router.asPath]);

  useEffect(() => {
    const onHanlder = (event) => {
      setSearchVisible(event.detail);
    };
    window.addEventListener(EVENT.CHANGE_SEARCH_INPUT_VISIBLE, onHanlder);
    return () => {
      window.removeEventListener(EVENT.CHANGE_SEARCH_INPUT_VISIBLE, onHanlder);
    };
  }, []);

  return (
    <>
      <div
        className={classNames([styles.header, isHome ? styles.home : null])}
        data-content-source="导航栏"
        ref={headerRef}
        data-source="顶部导航栏"
      >
        {!sideNavVisible && <LogoWithOrg />}

        {!isMobile && (
          <div className={styles.searchWrapper}>
            <Search
              className={classNames(styles.search, {
                [styles.hide]: isHome && !searchVisible,
              })}
              initValue={searchWord}
              bordered
              isNewLayout
            />
          </div>
        )}
        <div className={styles.tools}>
          <MembershipDropdown />
          {user && <NotificationCenter />}
          {user?.user_id ? <Avatar isNewLayout linkTo="/space" /> : <Login />}
        </div>
      </div>
    </>
  );
}

function Login() {
  const { login } = useLogin();
  return (
    <TrackerDiv
      className={styles.login}
      data-gd-expose="button_expose"
      data-gd-click="button_click"
      data-module-name="顶部导航栏"
      data-subject-name="按钮"
      data-button-name="登陆注册"
      onClick={async () => {
        login({
          target: "blank",
          source_location: "顶部导航栏-登录/注册",
        });
      }}
    >
      登录/注册
    </TrackerDiv>
  );
}
